import { ApolloClient, ApolloLink, ApolloProvider, from, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import cookies from 'browser-cookies';

import { API_URL } from 'constants/API';
import { SHOW_DEBUG } from 'constants/DEBUG';
import getDomainLanguage from 'helpers/getDomainLanguage';
import React, { Component } from 'react';
import { GraphQLClientContext } from './GraphQLClientContext';

const { Provider } = GraphQLClientContext;
const DEFAULT_APOLLO_CLIENT_OPTIONS = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  },
};

export default class GraphQLClientState extends Component {
  state = {
    apollo_client_is_initialized: false,
    // флаг доступности АПИ
    isAPIOnLine: false,
  };
  cache = new InMemoryCache({
    dataIdFromObject: item => item._id ? `${item.__typename}:${item._id}` : null,
  });
  apolloClient = null;
  _wsSocket = null;

  render () {
    const {
      apolloClient,
      props: {
        children,
      },
      state: {
        apollo_client_is_initialized,
        isAPIOnLine,
      },
    } = this;

    if (!apollo_client_is_initialized) {
      return null;
    }

    return (
      <ApolloProvider {...{ client: apolloClient }}>
        <Provider value={{ isAPIOnLine, client: apolloClient }}>
          {children}
        </Provider>
      </ApolloProvider>
    );
  }

  _httpLink = null;

  get httpLink () {
    if (!this._httpLink) {
      this._httpLink = createUploadLink({ uri: API_URL });
    }

    return this._httpLink;
  }

  componentDidMount () {
    // создадим Аполло Клиент
    this.apolloClient = this.createApolloClient();
    this.setState(state => ({
      ...state,
      apollo_client_is_initialized: true,
    }));
  }

  get authLink () {
    return new ApolloLink(
      (
        operation,
        forward,
      ) => {
        operation.setContext(
          ({ headers }) => {
            return (
              {
                headers: {
                  authorization: this.token,
                  'Apollo-Require-Preflight': Date.now(),
                  'X-Lang': getDomainLanguage(),
                  ...headers,
                },
              }
            );
          },
        );

        return forward(operation);
      },
    );
  }

  get token () {
    const token = cookies.get('auth.token');

    return token ? `Bearer ${token}` : null;
  }

  /**
   * устанавливает статус канала API (online | offline)
   */
  setAPIStatus = (isOnLine = false) => {
    const { isAPIOnLine } = this.state;
    if (isAPIOnLine !== Boolean(isOnLine)) {
      this.setState({ isAPIOnLine: Boolean(isOnLine) });
    }
  };

  /**
   * Создает экземпляр Apollo Client
   * Экземпляр клиента помещается в стейт провайдера
   */
  createApolloClient () {
    const {
      cache,
      httpLink,
      authLink,
    } = this;

    const apolloClient = new ApolloClient({
      link: from([authLink, httpLink]),
      cache,
      connectToDevTools: SHOW_DEBUG,
      defaultOptions: DEFAULT_APOLLO_CLIENT_OPTIONS,
    });

    return apolloClient;
  }
}
